import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { FC } from 'react';

import { ButtonTheme } from '@/styles/themes/button';
import { BREAKPOINTS } from '@/styles/themes/default';
import { IThemeProps } from '@/styles/themes/types';

import { FilledButton } from '../../core/Button/variants/FilledButton';

export const slideToLeft = css`
  -webkit-animation: slideLeft 0.4s forwards;
  -webkit-animation-delay: 0.4s;
  animation: slideLeft 0.4s forwards;
  animation-delay: 0.4s;

  @-webkit-keyframes slideLeft {
    100% {
      left: 0;
    }
  }

  @keyframes slideLeft {
    100% {
      left: 0;
    }
  }
`;

export const slideToRight = css`
  -webkit-animation: slideRight 0.4s forwards;
  -webkit-animation-delay: 0.4s;
  animation: slideRight 0.4s forwards;
  animation-delay: 0.4s;

  @-webkit-keyframes slideRight {
    100% {
      right: 0;
    }
  }

  @keyframes slideRight {
    100% {
      right: 0;
    }
  }
`;

export const delayedAnimation = (delay) => css`
  -webkit-animation-delay: ${delay}s;
  animation-delay: ${delay}s;
`;

export const Card = styled.div<IThemeProps>`
  background-color: #fff;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 14px;
  line-height: 20px;
  color: black;
  position: absolute;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);

  svg {
    width: 24px;
    height: 24px;
    margin-right: 8px;
    color: ${({ theme }) => theme.legacy.colors.brand.primary};

    @media (min-width: ${BREAKPOINTS.Desktop.min}px) {
      margin-right: 18px;
    }
  }
`;

const ButtonStyled = styled(FilledButton)<IThemeProps>`
  padding-top: 13px;
  padding-bottom: 13px;
  background-color: ${({ theme }) => theme.legacy.colors.brand.signalRed};
  height: min-content;
  align-self: end;
  text-decoration: none;
  color: #fff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
  margin-right: 10px;
  cursor: default;

  :hover {
    color: white;
    text-decoration: none;
    background-color: ${({ theme }) => theme.legacy.colors.brand.signalRed};
  }
`;

const LiveCircle = styled.span`
  width: 12px;
  height: 12px;
  background: #fff;
  border-radius: 50%;
  margin-right: 8px;
`;

interface ILiveButtonProps {
  label: string;
}

export const LiveButton: FC<ILiveButtonProps> = ({ label, ...restProps }) => (
  <ButtonStyled {...restProps} type="button" buttonTheme={ButtonTheme.DARK}>
    <LiveCircle />
    {label}
  </ButtonStyled>
);
